import RpcInputException from "../../../../../server/com/silkplm/engine/rpc/exceptions/RpcInputException.js";

class RelatedRecordsException extends RpcInputException {
    /**
     *  @class RelatedRecordsException
     *  @alias module:src/server/com/silkplm/rpc/exceptions/RelatedRecordsException.RelatedRecordsException
     *
     * */
    constructor(rpcObject, ...params){
        super(rpcObject, ...params);

    }
}

/** @module src/server/com/silkplm/rpc/exceptions/RelatedRecordsException */
export default RelatedRecordsException

export { RelatedRecordsException }
